import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { ControlOutlined } from '@ant-design/icons';

import ButtonSmallIcon from 'common/components/button/ButtonSmallIcon';

import selectorsGridView from 'common/components/grid-view/controllers/selectors';

import * as actionGlobal from '@redux/global/actions';
import * as selectorsGlobal from '@redux/global/selectors';

import { useGlobalModal } from 'hooks';

import Messages from 'i18n/messages/home';

import * as actionsGridView from 'common/components/grid-view/controllers/actions';

import * as actions from '@redux/global/actions';

const ManageGridQuery = (props) => {
  const dispatch = useDispatch();

  const isAddToFolderShow = useSelector(
    selectorsGlobal.selectShowAddToFolder()
  );
  const isDetailShow = useSelector(selectorsGridView.makeSelectVisible());

  const { MODAL_NAMES, openModal } = useGlobalModal();

  const openModalManageQueries = () => {
    if (isAddToFolderShow) dispatch(actionGlobal.toggleAddToFolder());
    if (isDetailShow) dispatch(actionsGridView.updateVisible(false));
    dispatch(actions.hideDetail());
    openModal(MODAL_NAMES.MANAGE_QUERIES);
  };
  return (
    <>
      <ButtonSmallIcon
        icon={<ControlOutlined />}
        label={Messages.manageConfig}
        onClick={openModalManageQueries}
        className='grid-config__button'
      />
    </>
  );
};

export default ManageGridQuery;
